// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkFollowSuggestion-cls1_9Xp","cls2":"BulkFollowSuggestion-cls2_yft BulkFollowSuggestion-cls1_9Xp"};